<celum-dialog class="standard-dialog" [hideCloseAllBtn]="hideCloseAllBtn" (onCloseAll)="closeAll($event)">
  @if (headerText) {
    <celum-dialog-header>
      {{ headerText | translate }}
    </celum-dialog-header>
  }
  @if (errors?.length > 0) {
    <celum-dialog-error>
      @for (error of errors; track error) {
        <div>{{ error }}</div>
      }
    </celum-dialog-error>
  }
  <celum-dialog-content>
    <ng-content></ng-content>
    {{ message | translate }}
  </celum-dialog-content>
  @if (buttons.length > 0) {
    <celum-dialog-footer
      [buttons]="buttons"
      [cancelBtnText]="cancelBtnText"
      [color]="color"
      [confirmBtnText]="confirmBtnText"
      [disableOnEnterConfirmation]="disableOnEnterConfirmation"
      [loading]="loading"
      [valid]="valid"
      (onCancel)="cancel($event)"
      (onConfirm)="confirm($event)"></celum-dialog-footer>
  }
</celum-dialog>
